import SignUpBySignUpCodeView from '@/views/SignUpBySignUpCodeView';

export default function SignUp() {
  return <SignUpBySignUpCodeView />;
}
